import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import UserHeader from "./UserHeader";
import Footer from "../Home/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import AxiosInstance from "../Home/AxiosInstance";
import "./UserProfile.css";
import "./employerPortal.css";

export default function UserProfile() {
  const [userProfiles, setUserProfiles] = useState([]);
  const [error, setError] = useState(null);
  const [roles, setRoles] = useState([]);
  const [profileName, setProfileName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userId, setUserId] = useState(null);
  const [userRole, setUserRole] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const profilesPerPage = 6;
  const navigate = useNavigate();

  const fetchRoles = async () => {
    try {
      const response = await AxiosInstance.get(
        "companies/roles/"
      );
      setRoles(response.data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const fetchProfiles = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const profilesResponse = await AxiosInstance.get(
        `companies/user/profile/${userId}/`
      );
      setUserProfiles(profilesResponse.data);
    } catch (error) {
      console.error("Error fetching user profiles:", error);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchProfiles();
  }, []);

  const resetForm = () => {
    setProfileName("");
    setEmail("");
    setRole("");
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userId = parseInt(localStorage.getItem("userId"));
      const storedRoleName = localStorage.getItem("role");

      // Find the role ID corresponding to role name
      const roleObj = roles.find(
        (r) => r.role.toLowerCase() === storedRoleName.toLowerCase()
      );
      if (!roleObj) {
        alert("User role is invalid or missing.");
        return;
      }
      const roleId = roleObj.role_id;

      const profileData = {
        profile_name: profileName,
        email,
        role: roleId,
        user: userId,
      };

      await AxiosInstance.post("companies/profile/", profileData);
      fetchProfiles();
      setIsModalOpen(false);
      resetForm();
    } catch (err) {
      console.error("Error adding profile:", err);
      alert("Failed to add profile.");
    }
  };

  useEffect(() => {
    const role = localStorage.getItem("role");
    setUserRole(role);
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem("userId");
    if (stored) setUserId(parseInt(stored));
  }, []);

  // Pagination logic
  const indexOfLastProfile = currentPage * profilesPerPage;
  const indexOfFirstProfile = indexOfLastProfile - profilesPerPage;
  const currentProfiles = userProfiles.slice(
    indexOfFirstProfile,
    indexOfLastProfile
  );
  const totalPages = Math.ceil(userProfiles.length / profilesPerPage);
  return (
    <div className="CompanyPage als-employer-page">
      <UserHeader />
      <div className="company-container my-4">
        <div className="mb-3">
          <button
            className="navigate-button btn btn-outline-primary d-flex align-items-center"
            onClick={() => navigate(-1)}
            style={{ gap: "6px" }}
          >
            <FiArrowLeft /> Back
          </button>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="section-heading">Profiles</h2>
          <button
            className="btn btn-primary"
            onClick={() => {
              setIsModalOpen(true);
              resetForm();
            }}
          >
            Add Profile
          </button>
        </div>

        <div className="row">
          {currentProfiles.length > 0 ? (
            currentProfiles.map((profile, index) => (
              <div key={index} className="col-md-4 mb-4">
                <div
                  className="card h-100 shadow-sm"
                  onClick={() => navigate(`/profile/${profile.profile_id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="card-body">
                    <h5 className="card-title">{profile.profile_name}</h5>
                    <p className="card-text">
                      <strong>Email:</strong> {profile.email}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No profiles found</p>
          )}
        </div>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <span>
              Page {currentPage} of {totalPages}
            </span>

            <button
              className="btn btn-outline-primary"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}

        {/* Bootstrap Modal */}
        {isModalOpen && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Profile</h5>
                </div>
                <div className="modal-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Profile Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={profileName}
                        onChange={(e) => setProfileName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setIsModalOpen(false)}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save Profile
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
